/**
 * Node customizado para Adicionar Fase (Kanban)
 * Exibe categoria e fase selecionadas
 * Inclui toolbar flutuante ao selecionar
 * 
 * RELEASE: 1.0.0 - 2024-12-26 - Novo componente
 */

import { Handle, Position, NodeProps } from '@xyflow/react';
import { LayoutGrid } from 'lucide-react';
import { FlowNodeData, AssignPhaseConfig } from '@/types/flows';
import { FlowNodeToolbar } from './FlowNodeToolbar';

/**
 * Componente visual do node Adicionar Fase
 */
export function AssignPhaseNode({ data, id, selected }: NodeProps) {
  const nodeData = data as FlowNodeData;
  const config = nodeData.config as AssignPhaseConfig | undefined;
  
  // Callbacks injetados via FlowCanvas
  const onEdit = (nodeData as any).onEdit;
  const onDuplicate = (nodeData as any).onDuplicate;
  const onDelete = (nodeData as any).onDelete;
  const onTestFromHere = (nodeData as any).onTestFromHere;
  
  // Monta texto de detalhe baseado na configuração
  const getDetail = () => {
    if (!config?.category_name || !config?.phase_name) {
      return 'Fase não configurada';
    }
    return `${config.category_name} → ${config.phase_name}`;
  };

  return (
    <div className="bg-card rounded-lg shadow-lg border-2 border-teal-500 min-w-[200px] max-w-[260px]">
      {/* Toolbar flutuante */}
      <FlowNodeToolbar
        nodeId={id}
        nodeType={nodeData.type}
        onEdit={onEdit}
        onDuplicate={onDuplicate}
        onDelete={onDelete}
        onTestFromHere={onTestFromHere}
        isVisible={selected}
      />
      
      <Handle
        type="target"
        position={Position.Top}
        className="!bg-teal-500 !w-3 !h-3"
      />
      
      <div className="p-3">
        <div className="flex items-center gap-2 mb-2">
          <div className="bg-teal-500/10 text-teal-600 p-2 rounded">
            <LayoutGrid className="h-4 w-4" />
          </div>
          <div className="flex-1">
            <div className="font-semibold text-sm text-foreground">
              {nodeData.config?.nickname || 'Adicionar Fase'}
            </div>
          </div>
        </div>
        
        <div className="text-xs text-muted-foreground bg-muted/50 rounded p-2">
          {getDetail()}
        </div>
      </div>
      
      <Handle
        type="source"
        position={Position.Bottom}
        className="!bg-teal-500 !w-3 !h-3"
      />
    </div>
  );
}
